import './chip.css'

function Chip(props) {

    return (
        <section style={props.style} className="body-chip-component">
            {
                props.items.map((value, i) => {
                    return (
                        <div onClick={()=> props.onClick(value.route)} key={i} style={{ width: `calc(100% / ${props.quantity})` }} className={`container-chip-component ${props.active === i ? 'chipactive' : ''}`}>
                            <h1>{value.title}</h1>
                            <img src={value.img} alt='table' />
                        </div>
                    )
                })
            }
        </section>
    )
}

export default Chip